import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const Result = () => {
  let location = useLocation();
  let {state, level} = location;
  let navigate = useNavigate();
  
  return (
    <>
    <div className="wrapper position-relative">
      <div className="container">
        <div className="multisteps_form position-relative overflow-hidden" id="wizard">
          <center>
          <h1>Your level is {state.level}</h1>
          <p>An email with your results sent to your email address, check your inbox.</p>
          <button onClick={()=> navigate('/quiz')}>Retake</button>
          </center>
        </div>
      </div>
    </div>
      </>
  )
}

export default Result